import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { MatOptionTemplateComponent } from './mat-option-template/mat-option-template.component';
import { SelectFormControlComponent } from './select-form-control.component';
import { TemplateSelectTriggerComponent } from './template-select-trigger/template-select-trigger.component';



@NgModule({
  declarations: [
    SelectFormControlComponent,
    MatOptionTemplateComponent,
    TemplateSelectTriggerComponent
  ],
  exports: [
    SelectFormControlComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule,
    MatSelectModule,
    TranslateModule
  ]
})
export class SelectFormControlModule { }
